(() => {
class EAHomeStoryCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.ea-home-story-grid');
    this.previous = this.querySelector('.ea-home-story-prev');
    this.next = this.querySelector('.ea-home-story-next');
    if (!this.track || !this.previous || !this.next) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.desktop = window.matchMedia('(min-width: 760px)');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.update = () => {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      this.track.tabIndex = this.desktop.matches ? 0 : -1;
    };
    this.move = (direction) => {
      if (!this.desktop.matches) return;
      const card = this.track.querySelector('.ea-home-story');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
    };
    this.previous.addEventListener('click', () => this.move(-1), options);
    this.next.addEventListener('click', () => this.move(1), options);
    this.track.addEventListener('scroll', this.update, { ...options, passive: true });
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track || !this.desktop.matches) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }
    }, options);
    this.desktop.addEventListener('change', this.update, options);
    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this.track);
    this.setAttribute('data-carousel-ready', '');
    this.update();
  }
  disconnectedCallback() {
    this.events?.abort();
    this.observer?.disconnect();
  }
}
if (!customElements.get('ea-home-story-carousel')) customElements.define('ea-home-story-carousel', EAHomeStoryCarousel);
})();
